import type {
  ComprehensiveProductType,
  PinnedScrollWidgetConfigType,
} from '@atlassian/mpac-widgets';

import adaptiveAutomationPoster from '../assets/productAssets/adaptiveAutomationPoster.png';
import adaptiveWorkflow from '../assets/productAssets/adaptiveWorkflow.svg';
import blueHighlight from '../assets/productAssets/blueHighlight.svg';
import collectiveIntelligencePoster from '../assets/productAssets/collectiveIntelligencePoster.png';
import connectedIntelligence from '../assets/productAssets/ConnectedIntelligence.svg';
import greenHighlight from '../assets/productAssets/greenHighlight.svg';
import purpleHighlight from '../assets/productAssets/purpleHighlight.svg';
import smartInsights from '../assets/productAssets/SmartInsights.svg';
import smartInsightsPoster from '../assets/productAssets/smartInsightsPoster.png';

const products: ComprehensiveProductType[] = [
  {
    productName: 'Smart Insights',
    logo: smartInsights,
    productCTA: {
      text: 'Explore apps',
      url: '/collections/ai-and-rovo?useCases=Analytics&useCases=Knowledge+Base&useCases=Reporting&useCases=Search&useCases=Charts%2FGraphs',
      ariaLabel: 'Explore AI apps for quick insights and smart actions',
      analytics: {
        actionSubjectId: 'explore_apps',
        attributes: {
          productName: 'smart_insights',
        },
      },
    },
    header: 'From data to decisions',
    description:
      'AI apps turn your content into quick summaries, actionable tasks, and clear answers, all while cutting manual effort and getting fast clarity.',
    posterImage: smartInsightsPoster,
    keywordsConfig: {
      items: ['SUMMARIZE', 'ANALYZE', 'DISCOVER'],
      highlight: blueHighlight,
    },
  },
  {
    productName: 'Adaptive automation',
    logo: adaptiveWorkflow,
    productCTA: {
      text: 'Explore apps',
      url: '/collections/ai-and-rovo?useCases=Audit&useCases=CI%2FCD&useCases=Monitoring&useCases=Notifications&useCases=Resource+management&useCases=Testing+%26+QA&useCases=Workflow',
      ariaLabel: 'Explore AI apps for smart and adaptive workflow automation',
      analytics: {
        actionSubjectId: 'explore_apps',
        attributes: {
          productName: 'adaptive_automation',
        },
      },
    },
    header: 'Workflows that work for you',
    description:
      'AI apps go beyond rule-based tools by predicting, generating, and triaging in real time, automating tasks that regular apps simply can’t.',
    posterImage: adaptiveAutomationPoster,
    keywordsConfig: {
      items: ['RESOLVE', 'VALIDATE', 'LEARN'],
      highlight: purpleHighlight,
    },
  },
  {
    productName: 'Connected intelligence',
    logo: connectedIntelligence,
    productCTA: {
      text: 'Explore apps',
      url: '/collections/ai-and-rovo?useCases=CRM&useCases=Code+Collaboration&useCases=Documentation&useCases=Knowledge+Base&useCases=Calendar+Management',
      ariaLabel: 'Explore AI apps that support intelligent collaboration through conversation',
      analytics: {
        actionSubjectId: 'explore_apps',
        attributes: {
          productName: 'connected_intelligence',
        },
      },
    },
    header: 'Clarity through conversation',
    description:
      'Built-in AI brings natural language chat, smart search, OCR, and governance right into Jira, Confluence, and more, making every interaction seamless and secure.',
    posterImage: collectiveIntelligencePoster,
    keywordsConfig: {
      items: ['COLLABORATE', 'ORCHESTRATE', 'MEASURE'],
      highlight: greenHighlight,
    },
  },
];

const AIInfoPinnedScrollWidgetConfig: PinnedScrollWidgetConfigType = {
  heading: 'What makes an app truly AI?',
  subHeading:
    'An AI app harnesses artificial intelligence at its core to automate tasks, surface valuable insights, and tailor your Atlassian experience, so your team can work smarter and move faster.',
  products,
};

export default AIInfoPinnedScrollWidgetConfig;
